import React, { PropTypes } from 'react';
import { getLocalMoment } from 'time';

/**
 * Activity Item Time Stamp
 */
const ItemTimeStamp = (props) => {
  let { createdOn } = props;

  let momLocal = getLocalMoment(createdOn);
  let date = momLocal.format('L');
  let time = momLocal.format('h:mm:ss a');

  return (
    <div className="af-list-item-time-stamp">
      <div className="af-list-item-time-stamp-date">{date}</div>
      <span></span>
      <div className="af-list-item-time-stamp-time">{time}</div>
    </div>
  );
};

ItemTimeStamp.propTypes = {
  createdOn: PropTypes.number,
};

export default ItemTimeStamp;
